/**
 * Сравнение текущего pathname с url пункта меню (игнорируя query string).
 */
export const isMenuUrlActive = (url, pathname) => {
  if (!url) {
    return false;
  }
  const q = url.indexOf("?");
  const pathOnly = q >= 0 ? url.slice(0, q) : url;
  return pathname === pathOnly;
};
